import { forwardRef } from 'react';
import classNames from 'classnames';

import type { ActionItemButtonProps } from './action-button.type';
import { ACTION_ITEM_BUTTON_CLASSES, ACTION_ITEM_BUTTON_DISABLED_CLASSES } from './config';

export const ActionItemButton = forwardRef<HTMLButtonElement, ActionItemButtonProps>(
  ({ text, Icon, icon, active, customTextColor, dataTestId, className, ...rest }, ref) => (
    <button
      type='button'
      ref={ref}
      data-testid={dataTestId}
      className={classNames(
        ACTION_ITEM_BUTTON_CLASSES,
        {
          'text-primary': !customTextColor,
          'fill-secondary': !active,
          'fill-secondary-active': active,
          [`cursor-pointer-none pointer-events-none ${ACTION_ITEM_BUTTON_DISABLED_CLASSES}`]: rest.disabled,
        },
        customTextColor,
        className
      )}
      {...rest}>
      {Icon && <Icon className='w-6 h-6 text-primary text-center' />}
      {icon && <span className='w-6 h-6 flex items-center justify-center'>{icon}</span>}
      {text}
    </button>
  )
);
